import { FormControl, FormErrorMessage, FormLabel } from '@chakra-ui/react'
import { ReactElement, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { IKReactSelect } from '../../../../../ui-kit'
import type { CMFieldProps } from '.'

const CMMultiSelectField = ({
  cmField,
  disabled,
  isUpload,
  form,
}: CMFieldProps): ReactElement => {
  const { t } = useTranslation()
  const [cmFieldSelectOptions, setCmFieldSelectOptions] =
    useState<Array<string | number | boolean>>()
  const [formattedValue, setFormattedValue] = useState<
    Array<{
      label: string
      value: string | boolean | number
    }>
  >()

  useEffect(() => {
    let tempFormattedValue: Array<{
      label: string
      value: string | boolean | number
    }> = []

    if (
      form?.values?.upload &&
      Array.isArray(form?.values?.upload[cmField.name])
    ) {
      tempFormattedValue = form?.values?.upload[cmField.name].map(item =>
        typeof item !== 'object'
          ? {
              label: String(item),
              value: item,
            }
          : item,
      )
    }
    setFormattedValue(tempFormattedValue)
    setCmFieldSelectOptions(cmField.schema.selectOptions ?? [])
  }, [form?.values?.upload, cmField])

  return (
    <FormControl
      marginBottom={isUpload ? 0 : '30px'}
      isInvalid={Boolean(
        form.errors?.upload &&
          form.touched?.upload &&
          form.errors?.upload[cmField.name] &&
          form.touched?.upload[cmField.name],
      )}
      isRequired={cmField.schema.isValueRequired}
      isDisabled={disabled}
    >
      <FormLabel>{cmField.label}</FormLabel>
      <IKReactSelect
        placeholder={t('set_a_default_value', 'Set a default value')}
        variant="compact"
        captureMenuScroll={false}
        menuPlacement="auto"
        isClearable
        isMulti
        isDisabled={disabled}
        value={formattedValue}
        options={cmFieldSelectOptions?.map(item => ({
          label: String(item),
          value: item,
        }))}
        onChange={newVals => {
          form.setTouched({ ...form.touched, [cmField.name]: true })
          if (newVals.length === 0) {
            form.setFieldValue(`upload.['${cmField.name}']`, null)
          } else {
            form.setFieldValue(
              `upload.['${cmField.name}']`,
              newVals?.map(newVal => newVal.value),
            )
          }
        }}
      />
      <FormErrorMessage>
        {form.errors?.upload && form.errors?.upload[cmField.name]}
      </FormErrorMessage>
    </FormControl>
  )
}

export default CMMultiSelectField
